// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/feature-badge/feature-badge.component.scss
// module id = 279
// module chunks = 0